import { styled, Button, ButtonProps, SxProps, Theme } from '@mui/material'
import { Icon, IconNames } from 'hello-design-system'
import { ReactElement } from 'react'

type StandardButtonProps = {
    onClick?: ButtonProps['onClick']
    id?: string
    color?: ButtonProps['color']
    iconSrc?: IconNames | ReactElement
    disabled?: boolean
    isDisabled?: boolean
    text?: string
    children?: React.ReactNode
    sx?: SxProps<Theme>
}

const StyledButton = styled(Button)<{ isDisabled?: boolean }>(({ theme, isDisabled }) => ({
    [theme.breakpoints.down('md')]: {
        height: theme.spacing(5),
        padding: theme.spacing(1),
        paddingLeft: theme.spacing(2)
    },
    '&.MuiButton-root': {
        fontSize: '16px',
        fontWeight: '600',
        lineHeight: '22px',
        '&.Mui-disabled': {
            backgroundColor: `${theme.palette.action?.disabledBackground} !important`,
            color: `${theme.palette.action?.disabled} !important`
        },
        '&.MuiButton-colorSecondary': {
            backgroundColor: isDisabled ? theme.palette.grey?.[600] + '33 !important' : theme.palette.grey?.[200],
            fontWeight: '400 !important',
            color: isDisabled ? theme.palette.grey?.[500] : theme.palette.grey?.[700],
            '.MuiSvgIcon-root': {
                fill: theme.palette.grey?.[800]
            }
        }
    }
}))

const StandardButton: React.FC<StandardButtonProps> = ({ onClick, id, color, iconSrc, text, disabled, isDisabled, children, sx }) => (
    <StyledButton
        id={id}
        disabled={disabled}
        isDisabled={isDisabled}
        onClick={onClick}
        variant='contained'
        color={color}
        startIcon={typeof iconSrc === 'string' ? <Icon iconName={iconSrc} /> : iconSrc}
        size='large'>
        {text}
        {children}
    </StyledButton>
)

type CommonButtonProps = { id?: string; active?: boolean; disabled?: boolean; onClick?: StandardButtonProps['onClick'] }

export type { StandardButtonProps, CommonButtonProps }
export { StandardButton }
